import { render } from "./WatchPage.vue?vue&type=template&id=53122766&scoped=true"
import script from "./WatchPage.vue?vue&type=script&lang=js"
export * from "./WatchPage.vue?vue&type=script&lang=js"

import "./WatchPage.vue?vue&type=style&index=0&id=53122766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53122766"]])

export default __exports__